import Banner from "../shared/Banner";
import bannerImg from "../assets/banner.svg";
import bannerImg2 from "../assets/banner2.svg";
import bannerImg3 from "../assets/banner3.svg";
import bannerImg4 from "../assets/banner4.svg";

const banners = [
  // Cumpleaños
  {
    id: "birthday",
    banner: bannerImg,
    heading: "¡Cumplimos 13 años de innovación! ",
    subheading:
      "¡Porque cumplimos 13 años haciendo historia junto a ti, todos nuestros productos tienen un 13% descuento!",
    btn2: "Celebremos juntos",
    priority: true,
    fetchPriority: "high",
    loading: "eager",
    decoding: "async",
  },

  // SENIAT
  {
    id: "seniat",
    banner: bannerImg2,
    heading: "Softwares certificados por el SENIAT ",
    subheading:
      "Los productos Innova están autorizados bajo la Providencia Administrativa N° SNAT/2024/000121.",
    btn2: "Mirar Providencia",
    priority: true,
    fetchPriority: "high",
    loading: "eager",
    decoding: "async",
  },

  // Innova Food & Drinks
  {
    id: "food",
    banner: bannerImg3,
    heading: "Sistema de restaurante en la nube ",
    subheading:
      "Garantizamos el crecimiento de tu restaurante con nuestro intuitivo sistema en la nube. ",
    btn2: "Probar Demo",
    priority: false,
    fetchPriority: "auto",
    loading: "lazy",
    decoding: "async",
  },

  // Registro en Innova Partners
  {
    id: "partners",
    banner: bannerImg4,
    heading: "Conviértete en distribuidor autorizado ",
    subheading:
      "Accede a nuestro programa para partners, comienza hoy mismo en conjunto con Innova. ",
    btn2: "Aplicar para distribuidor",
    priority: false,
    fetchPriority: "auto",
    loading: "lazy",
    decoding: "async",
  },
];

const Home = () => {
  return (
    <section className="md:px-12 p-4 max-w-screen-2xl mx-auto mt-24" id="home">
      <Banner banners={banners} />
    </section>
  );
};

export default Home;